import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import {useSelector, useDispatch} from "react-redux";
import Views from './Views';
import {closeDialog} from "../../store/actionCreators/dialog";
import '../../assets/stylesheets/Dialogs/Main.scss';
import '../../assets/stylesheets/Dialogs/RealDialog.scss';

const MainDialog = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const dialog = useSelector(state=>state.dialog);
    console.log(dialog);
    const View = Views[dialog.view];
    const title = (dialog.params && dialog.params.title) || dialog.view;
    const close = () => {
        dispatch(closeDialog());
    };

    let dialogClasses = ['realDialog', dialog.view];
    if (dialog.params) {
        if (dialog.params.fixed) dialogClasses.push('realDialog--fixed');
        if (dialog.params.grayHeader) dialogClasses.push('realDialog--grayHeader');
        if (dialog.params.noPaddings) dialogClasses.push('realDialog--noPaddings');
    }

    let modalClasses = [dialog.view];
    let headerClasses = [];
    
    if (dialog.params) {
        if (dialog.params.smallSize) modalClasses.push('smallSize');
        if (dialog.params.slimHeader) headerClasses.push('slim');
    }


    const onConfirm = useCallback(() => {
        if (dialog.params.onConfirm) dialog.params.onConfirm(dialog.params);
    }, [dialog]);

    const noFooter = dialog.params && dialog.params.noFooter;

    if (dialog.params && dialog.params.realDialog) return (
        <div className={dialogClasses.join(' ')}>
            <div className="realDialogOverlay" onClick={close} />
            <div className="realDialogBody">
                <header className="realDialogHeader">
                    {dialog.params && dialog.params.headerIcon ? (
                        <div className={`realDialogIcon realDialogIcon--${dialog.params.headerIcon}`} />
                    ) : false}
                    <span className="realDialogTitle">{t(`dialog.${title}`)}</span>
                    <div className={`realDialogCloseButton`} onClick={close}>
                        <i className={`fa fa-times`} />
                    </div>
                </header>
                <div className="realDialogContent">
                    <View {...dialog.params} />
                </div>
                {!noFooter ? (<footer className={`realDialogFooter`}>
                    {dialog.params && 
                     dialog.params.footer && 
                     typeof dialog.params.footer === 'function' ?
                     dialog.params.footer() :
                     false
                    }
                    {
                        dialog.params && 
                        dialog.params.footer && 
                        dialog.params.footer === 'cancelOrConfirm' && (
                        <React.Fragment>
                            <button className={`primary`} onClick={onConfirm}>{t('button.confirm')}</button>
                            <button className={`tertiary`} onClick={close}>{t('button.cancel')}</button>
                        </React.Fragment>
                    )}
                    {
                        dialog.params && dialog.params.footer && dialog.params.footer === 'confirm' && (
                        <button className={`primary`} onClick={onConfirm}>{t('button.confirm')}</button>
                    )}
                </footer>) : false }
            </div>
        </div>
    );
    
    return (
        <React.Fragment>
            { dialog.visible &&
            <dialog className={modalClasses.join(' ')}>
                <mask onClick={close} />
                <modal>
                    <header className={headerClasses.join(' ')}>
                        {title !== "clubInfo" && title !== "tournamentCasinoFinished" && <span>{t(`dialog.${title}`)}</span>}
                        <button className={`closeButton`} onClick={close}>
                            <i className=" fa close-icon fa-times " />
                        </button>
                    </header>
                    <view>
                        <View {...dialog.params} />
                    </view>
                </modal>
            </dialog>
            }
        </React.Fragment>
    );
};

export default MainDialog;
